import {
  Cancel,
  Close,
  ContentCopy,
  ContentPaste,
  Delete,
} from '@mui/icons-material'
import { Box, Button, Tooltip, Typography } from '@mui/material'

import useT from '@/i18n/useT'

type SelectedShelvesProps = {
  selectedShelves: number[]
  clearSelections: () => void
  handleDeleteShelves: () => void
  handleCopyShelves: () => void
  handlePasteShelf: () => void
  clipboardAvailable: boolean
  clipboardSource: { storeName: string; displayName: string } | null
}

const SelectedShelves: React.FC<SelectedShelvesProps> = ({
  selectedShelves,
  clearSelections,
  handleDeleteShelves,
  handleCopyShelves,
  handlePasteShelf,
  clipboardAvailable,
  clipboardSource,
}) => {
  const { t } = useT()
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button sx={{ minWidth: 0, p: 1 }} onClick={clearSelections}>
          <Close />
        </Button>
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <Tooltip title={t('editPlanogram.selectedShelves.copyShortcut')}>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ minWidth: 0, p: 1 }}
              onClick={handleCopyShelves}
            >
              <ContentCopy />
            </Button>
          </Tooltip>
          <Tooltip
            title={
              clipboardAvailable
                ? t('editPlanogram.selectedShelves.pasteShortcut')
                : t('editPlanogram.selectedShelves.pasteDisabled')
            }
          >
            <span>
              <Button
                variant="outlined"
                color="secondary"
                sx={{ minWidth: 0, p: 1 }}
                onClick={handlePasteShelf}
                disabled={!clipboardAvailable}
              >
                <ContentPaste />
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="outlined"
            color="error"
            sx={{ minWidth: 0, p: 1 }}
            onClick={handleDeleteShelves}
          >
            <Delete />
          </Button>
        </Box>
      </Box>
      <Typography>
        {t('editPlanogram.selectedShelves.numShelves', {
          count: selectedShelves.length,
        })}
      </Typography>
      {clipboardSource && (
        <Typography variant="body2" color="text.secondary">
          {t(
            'editPlanogram.selectedShelves.copiedFrom',
            'Copied from {storeName} / {displayName}',
            {
              storeName: clipboardSource.storeName,
              displayName: clipboardSource.displayName,
            },
          )}
        </Typography>
      )}
      <Button
        variant="contained"
        fullWidth
        startIcon={<Cancel />}
        onClick={clearSelections}
      >
        {t('editPlanogram.selectedShelves.clearSelection')}
      </Button>
    </>
  )
}

export default SelectedShelves
